module.exports = __webpack_public_path__ + "static/img/recommend-list-7.d0a8815.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/recommend-list-7.png
// module id = DyhA
// module chunks = 1